import { useState } from "react";

export type KeyedElement<T> = T & { key: number };
type EmptyElement<T> = T & { key?: never };


function useCollection<T>(emptyElement: EmptyElement<T>, checkCanAdd?: (collection:T[]) => boolean){
    function getKeyedElement(element: T): KeyedElement<T> {
        return { key: Date.now(), ...element };
    }

    const [collection, setCollection] = useState<KeyedElement<T>[]>([]);



    function addNewElement() {
        if(
            checkCanAdd && 
            !checkCanAdd(collection)){
            return;
        }
        setCollection([...collection, getKeyedElement(emptyElement)]);
    }
    function removeElement(index: number) {
        const newCollection = [...collection.filter((_, i) => i !== index)]
        setCollection(newCollection);
    }
    function modifyElement({
        index, 
        field, 
        value, 
        regex = undefined, 
        sizeLimit = undefined
    }){
        const newValue = typeof value === 'string' ? getStringValue({ value, regex, sizeLimit }) : value;
        const modifiedEnum = { ...collection[index], [field]: newValue };
        const newEnums = [...collection];
        newEnums[index] = modifiedEnum;
        setCollection(newEnums);
    }

    function getStringValue({ value, regex, sizeLimit }) {
        const cleanValue = regex ? value.replace(regex, '') : value;
        const trimmedValue = cleanValue.slice(0, sizeLimit)
        return trimmedValue;
    }

    return {
        collection,
        addNewElement,
        modifyElement,
        setCollection,
        removeElement
    }
}

export default useCollection;